export default "__VITE_ASSET__a35b0742__"